import React, { useState } from 'react';
import { cn } from '@/lib/utils';

interface OptimizedLogoProps {
  src: string;
  alt: string;
  className?: string;
  width?: number;
  height?: number;
  priority?: boolean;
  onError?: () => void;
  isLogo?: boolean;
}

export const OptimizedLogo: React.FC<OptimizedLogoProps> = ({
  src,
  alt,
  className,
  width,
  height,
  priority = false,
  onError
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isErrored, setIsErrored] = useState(false);

  const handleLoad = () => setIsLoaded(true);
  const handleError = () => {
    setIsErrored(true);
    if (onError) onError();
  };

  // For logos, use single optimized format
  const optimizedSrc = src.includes('unsplash') || src.includes('lovable-uploads') 
    ? `${src.split('?')[0]}?auto=format&fit=crop&w=${width || 200}&q=85&fm=webp`
    : src;

  return (
    <div className="relative inline-block">
      <img
        src={optimizedSrc}
        alt={alt}
        className={cn(
          "object-contain transition-opacity duration-200",
          isLoaded ? "opacity-100" : "opacity-0",
          className
        )}
        width={width}
        height={height}
        loading={priority ? "eager" : "lazy"}
        decoding="async"
        {...(priority ? { fetchpriority: "high" } as any : {})}
        onLoad={handleLoad}
        onError={handleError}
      />
      
      {/* Simple loading placeholder */}
      {!isLoaded && !isErrored && (
        <div 
          className="absolute inset-0 bg-muted animate-pulse rounded"
          style={{ width, height }}
        />
      )}
    </div>
  );
};